/**
 * The websites popular with the language's learners, opened from the iOS app's
 * Discover ("See all ›") and the website's footer (and Discover, when it finds
 * nothing)
 */
import * as preact from "preact";
import PopularDomainsView from "views/PopularDomainsView";
import * as languagePage from "./languagePage";
import type { PreactPageProps } from "./PreactPage";

export default class WebsitesPageView extends preact.Component<PreactPageProps> {
  private disposeLanguageWatch?: () => void;

  componentDidMount() {
    this.disposeLanguageWatch = languagePage.follow(this.props.appRouter);
    languagePage.setTitle(
      "Links",
      (languageName) =>
        `A collection of links to the most recommended websites for practicing to read ${languageName}.`
    );
  }

  componentWillUnmount() {
    this.disposeLanguageWatch?.();
  }

  render() {
    return (
      <div class="websites">
        <h1>Websites</h1>
        <PopularDomainsView />
      </div>
    );
  }
}
